import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import { smoothScrollWithOffset as smoothScroll } from "../../../../utils/scroll";
import PropTypes from 'prop-types';

const NavItems = ({ offset }) =>
  (<ul id="nav-items" className="nav navbar-nav">
    <li className="nav-item nav-link">
      <Link to="#how-it-works" data-track="topNav" scroll={smoothScroll(offset)}>How it works</Link>
    </li>
    <li className="nav-item nav-link">
      <Link to="#benefits" data-track="topNav" scroll={smoothScroll(offset)}>Benefits</Link>
    </li>
    <li className="nav-item nav-link">
      <Link to="#uses" data-track="topNav" scroll={smoothScroll(offset)}>Use</Link>
    </li>
    <li className="nav-item nav-link">
      <Link to="#faqs" data-track="topNav" scroll={smoothScroll(offset)}>FAQs</Link>
    </li>
    <li className="nav-item nav-link">
      <Link to="#who-we-are" data-track="topNav" scroll={smoothScroll(offset)}>About Us</Link>
    </li>
    <li className="external-links">
      <ul className="external-links p-0">
        <li className="nav-item nav-link">
          <a className="bcus-text-cyan" data-track="topNav" href="/applicationcenter">Check My Application</a>
        </li>
        <li className="nav-item nav-link">
          <a className="bcus-text-cyan" data-track="topNav" href="https://loans.barclaysus.com/pages/home">Log In</a>
        </li>
      </ul>
    </li>
  </ul>);

NavItems.propTypes = {
  offset: PropTypes.number.isRequired
};

NavItems.defaultProps = {
  offset: 0
};

export default NavItems;
